import { CardWrapper } from '@monorepo/common';
import { Button, Stack, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { book } from '../../routers/books';
import { getPrepaidPurchasePath } from '../../utils/jobAccountRoutes';

export const PrepaidListingExpired = () => {
  const { search } = useLocation();
  const siteId = Number(new URLSearchParams(search).get('siteId')) || null;

  return (
    <CardWrapper>
      <Typography
        variant="h4"
        marginBottom={2}
      >
        Prepaid Job Package Expired
      </Typography>
      <Typography color="text.secondary" marginBottom={3}>
        This prepaid package has expired and can no longer be used to post a listing.
        Purchase a new package or return to your Jobs dashboard.
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
        <Button component={Link} to={getPrepaidPurchasePath(siteId)} variant="contained">
          Buy a Job Package
        </Button>
        <Button component={Link} to={book.jobsPrepaid} variant="outlined">
          View Prepaid Packages
        </Button>
        <Button component={Link} to={book.jobsListings} variant="text">
          Manage Job Listings
        </Button>
      </Stack>
    </CardWrapper>
  );
};
